<template>
  <div>
    <v-row
        class="ma-0 pl-4 pr-2"
        style="background-color: #d1dcea"
      >
        <v-col cols="2" class="pa-4">
          <div class="px-2 pt-1">
            <b class="pr-2">TOTAIS</b><br />
          </div>
        </v-col>

        <v-col cols="10" class="pa-0">
          <v-row class="ma-0 pt-1 pr-11" style="justify-content: end">
            <v-col class="text-list text-right px-0 py-1" style="max-width: 8.6%">
              <small>Conciliado</small>
              <br/>
              <b>{{ pagamentosSumarizacao.percentualConciliado | formatPercent }}</b>
            </v-col>
            <v-col class="text-list text-right px-0 py-1" style="max-width: 12.6%">
              <small>Informado</small>
              <br/>
              <b>{{ pagamentosSumarizacao.totalInformado | formatPrice}}</b>
            </v-col>

            <v-col class="text-list text-right px-0 py-1" style="max-width: 14.6%">
              <small>Liberado</small>
              <br />
              <b><span style="color: green">{{ pagamentosSumarizacao.totalLiberado | formatPrice }}</span></b>
            </v-col>

            <v-col class="text-list text-right px-0 py-1" style="max-width: 14.6%">
              <small>Recursado</small>
              <br/>
              <b><span style="color: green">{{ pagamentosSumarizacao.totalRecursado | formatPrice }}</span></b>
            </v-col>

            <v-col class="text-list text-right px-0 py-1" style="max-width: 14.6%">
              <small>Acatado</small>
              <br/>
              <b><span style="color: red">{{ pagamentosSumarizacao.totalAcatado | formatPrice }}</span></b>
            </v-col>

            <v-col class="text-list text-right px-0 py-1" style="max-width: 14.6%">
              <small>Lib. produção</small>
              <br/>
              <b><span style="color: green">{{ pagamentosSumarizacao.totalLiberadoProducao | formatPrice }}</span></b>
            </v-col>

            <v-col class="text-list text-right px-0 py-1" style="max-width: 14.6%">
              <small>Glosa inicial</small>
              <br/>
              <b><span style="color: red">{{ GlosaProducao | formatPrice }}</span></b>
            </v-col>

            <v-col class="text-list text-right px-0 py-1" style="max-width: 14.6%">
              <small>Lib. recurso</small>
              <br/>
              <b><span style="color: green">{{ pagamentosSumarizacao.totalLiberadoRecurso | formatPrice }}</span></b>
            </v-col>

            <v-col class="text-list text-right px-0 py-1" style="max-width: 12.6%">
              <small>Glosa mantida</small>
              <br/>
              <b><span style="color: red">{{ pagamentosSumarizacao.totalGlosaMantida | formatPrice }}</span></b>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <p class="text-right ma-0 pa-0"><small>Valores em Reais (R$)</small></p>
  </div>
</template>

<script>
import { formatCurrency } from '../../../libs'

export default {
  computed: {
    GlosaProducao() {
      let val = this.pagamentosSumarizacao.totalGlosaInicial - this.pagamentosSumarizacao.totalGlosaMantida
      return val > 0 ? val : 0
    }
  },
  props: {
    pagamentosSumarizacao: Object
  },
  filters: {
    formatPercent (value) {
      const formatter = new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 })
      return formatter.format(value)
    },
    formatCurrency (value) {
      return formatCurrency(value)
    }
  }
}
</script>
